// Ported from the reference Order app's
// manage-order-tabs/common/utility/filter-transport-stops.ts - keeps only
// the stops on a transport that actually pick up or deliver this shipment.
export const filterTransportStops = (
  stops: Record<number, any>,
  shipmentNumber: string,
  transportationNumber: string,
  transportId: string,
  carrierId: string
) => {
  if (!stops) return [];

  return Object.entries(stops)
    .map(([key, stop]) => ({
      stopSequence: Number(key),
      transportationNumber,
      transportId,
      carrierId,
      ...(stop as object)
    }))
    .filter(({ pickups = [], deliveries = [] }: any) => {
      const hasPickup = pickups.some(
        (p: any) => p?.shipmentNumber === shipmentNumber
      );
      const hasDelivery = deliveries.some(
        (d: any) => d?.shipmentNumber === shipmentNumber
      );
      return hasPickup || hasDelivery;
    });
};

export default filterTransportStops;
